<template>
  <div>
    <transition name="fade">
      <div v-if="$parent.showPopup" class="popup">
        <div @click="$parent.showPopup = false" class="offclick"></div>
        <div class="holder">
          <p @click="$parent.showPopup = false" class="close">x</p>
          <transition name="fade-quick">
            <div v-if="$parent.status == 'submit'">
              <p class="title">Login to your account</p>
              <div class="inputs">
                <div class="input full">
                  <label>Email Address <span class="required">*</span></label>
                  <input type="text" placeholder="Type here" v-model="email" />
                </div>
                <div class="input">
                  <label>Password <span class="required">*</span></label>
                  <input type="password" v-model="password" />
                </div>
                <transition name="fade-quick">
                  <div v-if="!loading" class="btns">
                    <button @click="login()" class="btn">Login</button>
                    <router-link to="/forgot-password">
                      <button
                        @click="$parent.showPopup = false"
                        class="btn text_btn"
                      >
                        Forgot Password
                      </button>
                    </router-link>
                  </div>
                </transition>
                <transition name="fade-quick">
                  <div class="btns" v-if="loading">
                    <img class="login-loader" src="@/assets/img/loader.gif" />
                  </div>
                </transition>
              </div>
              <transition name="fade-quick">
                <p class="error" v-if="error">{{ error }}</p>
              </transition>
            </div>
          </transition>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const auth = fb.default.auth;
const functions = fb.default.functions;

export default {
  name: "cart-popup",
  data() {
    return {
      error: null,
      email: null,
      password: null,
      loading: false,
    };
  },
  methods: {
    validate() {
      this.error = null;
      return Boolean(this.email && this.password);
    },
    login() {
      if (this.validate()) {
        this.loading = true;
        auth
          .signInWithEmailAndPassword(this.email, this.password)
          .then((res) => {
            this.$store.dispatch("setReseller", res.user.uid).then(() => {
              this.loading = false;
              this.$parent.showPopup = false;
              this.$router.push("/dashboard");
            });
          })
          .catch((err) => {
            this.loading = false;
            this.error = err.message;
          });
      } else {
        this.error = "Missing Required Fields";
      }
    },
  },
};
</script>

<style scoped>
.popup {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 199;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(53, 73, 94, 0.75);
}

.login-loader {
  height: 50px;
  display: block;
  width: auto !important;
}

.title {
  font-size: 30px;
  font-weight: bold;
  font-family: "SFProDisplay", sans-serif;
  margin-top: 0;
}

.offclick {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  height: 100%;
  width: 100%;
}

.holder {
  position: relative;
  z-index: 2;
  padding: 50px;
  width: 500px;
  background-color: white;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  max-height: 600px;
  overflow: auto;
}

.not_found .holder {
  max-height: 100%;
  overflow: auto;
}

.holder input {
  width: 100%;
  box-sizing: border-box;
}

.holder .txt_btn {
  font-size: 23px;
}

.thanks {
  text-align: center;
}

.loader {
  width: 200px !important;
  margin: auto;
}

.holder {
  padding: 50px;
}

.holder p {
  line-height: 1.2;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.fade_delay-enter-active,
.fade_delay-leave-active {
  transition: opacity 0.5s;
  transition-delay: 0.5s;
}
.fade_delay-enter, .fade_delay-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.close {
  font-size: 25px;
  font-weight: bold;
  opacity: 0.4;
  padding: 10px 20px;
  margin: 0;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}

.btns {
  width: 100%;
}

.error {
  text-align: left;
}
</style>
